import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer7 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) {
            setEmail('');
        }
    };

    const collectionsLinks = [
        { label: 'Evening Wear', path: '/template7/shop' },
        { label: 'Silk Sarees', path: '/template7/shop' },
        { label: 'Designer Lehengas', path: '/template7/shop' },
        { label: 'Statement Jewelry', path: '/template7/shop' },
        { label: 'Bridal Collection', path: '/template7/shop' },
    ];

    const customerCareLinks = [
        { label: 'Contact Us', path: '/template7/contact' },
        { label: 'Shipping Policy', path: '/template7/shipping-exchange' },
        { label: 'Returns & Exchange', path: '/template7/shipping-exchange' },
        { label: 'FAQs', path: '/template7/faqs' },
        { label: 'Track Order', path: '/template7/orders' },
    ];

    const legalLinks = [
        { label: 'Privacy Policy', path: '/template7/privacy-policy' },
        { label: 'Terms & Conditions', path: '/template7/terms-conditions' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Lora:wght@400;500;600;700&family=Inter:wght@300;400;500&display=swap');
                .chandni-footer-grid {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 40px;
                }
                @media (min-width: 768px) {
                    .chandni-footer-grid {
                        grid-template-columns: 1.5fr 1fr 1fr 1.2fr;
                        gap: 48px;
                    }
                }
            `}</style>

            <footer
                style={{
                    background: 'linear-gradient(135deg, #1E1B4B 0%, #312E81 50%, #1E1B4B 100%)',
                    borderTop: '1px solid rgba(99, 102, 241, 0.2)',
                }}
            >
                <div
                    style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '64px 24px',
                    }}
                >
                    <div className="chandni-footer-grid">
                        {/* Column 1: Brand */}
                        <div>
                            <h3
                                style={{
                                    fontFamily: "'Lora', Georgia, serif",
                                    fontSize: '28px',
                                    fontWeight: 600,
                                    color: '#FFFFFF',
                                    letterSpacing: '3px',
                                    margin: '0 0 16px 0',
                                }}
                            >
                                CHANDNI
                            </h3>
                            <p
                                style={{
                                    fontFamily: "'Lora', Georgia, serif",
                                    fontSize: '14px',
                                    color: '#A5B4FC',
                                    lineHeight: 1.7,
                                    margin: '0 0 24px 0',
                                    fontStyle: 'italic',
                                }}
                            >
                                Moonlit Elegance
                            </p>
                            <p
                                style={{
                                    fontFamily: "'Inter', sans-serif",
                                    fontSize: '13px',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    lineHeight: 1.7,
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Where moonlight meets couture. Ethereal designs inspired by the night sky, crafted for the modern Indian woman.
                            </p>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                {[Instagram, Facebook].map((Icon, i) => (
                                    <a
                                        key={i}
                                        href="#"
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            border: '1px solid rgba(165, 180, 252, 0.3)',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            transition: 'all 0.3s ease',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#6366F1';
                                            e.currentTarget.style.borderColor = '#6366F1';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                            e.currentTarget.style.borderColor = 'rgba(165, 180, 252, 0.3)';
                                        }}
                                    >
                                        <Icon size={16} style={{ color: '#FFFFFF' }} />
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Column 2: Collections */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Inter', sans-serif",
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    color: '#A5B4FC',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 20px 0',
                                }}
                            >
                                Collections
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {collectionsLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Inter', sans-serif",
                                                fontSize: '14px',
                                                color: 'rgba(255, 255, 255, 0.6)',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                            }}
                                            onMouseEnter={(e) => (e.currentTarget.style.color = '#FFFFFF')}
                                            onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255, 255, 255, 0.6)')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 3: Customer Care */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Inter', sans-serif",
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    color: '#A5B4FC',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 20px 0',
                                }}
                            >
                                Customer Care
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {customerCareLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Inter', sans-serif",
                                                fontSize: '14px',
                                                color: 'rgba(255, 255, 255, 0.6)',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                            }}
                                            onMouseEnter={(e) => (e.currentTarget.style.color = '#FFFFFF')}
                                            onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255, 255, 255, 0.6)')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 4: Contact & Newsletter */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Inter', sans-serif",
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    color: '#A5B4FC',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 20px 0',
                                }}
                            >
                                Get in Touch
                            </h4>
                            <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Mail size={14} style={{ color: '#A5B4FC' }} />
                                <span style={{ fontFamily: "'Inter', sans-serif", fontSize: '13px', color: 'rgba(255,255,255,0.6)' }}>
                                    hello@chandni.com
                                </span>
                            </div>
                            <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Phone size={14} style={{ color: '#A5B4FC' }} />
                                <span style={{ fontFamily: "'Inter', sans-serif", fontSize: '13px', color: 'rgba(255,255,255,0.6)' }}>
                                    +91 98765 43210
                                </span>
                            </div>
                            <div style={{ marginBottom: '24px', display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                <MapPin size={14} style={{ color: '#A5B4FC', marginTop: '2px' }} />
                                <span style={{ fontFamily: "'Inter', sans-serif", fontSize: '13px', color: 'rgba(255,255,255,0.6)', lineHeight: 1.5 }}>
                                    12 Moonlight Lane, Bandra West, Mumbai 400050
                                </span>
                            </div>
                            <form onSubmit={handleSubscribe} style={{ display: 'flex', gap: '8px' }}>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Your email"
                                    style={{
                                        flex: 1,
                                        padding: '10px 14px',
                                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                                        border: '1px solid rgba(165, 180, 252, 0.2)',
                                        borderRadius: '4px',
                                        color: '#FFFFFF',
                                        fontSize: '13px',
                                        fontFamily: "'Inter', sans-serif",
                                        outline: 'none',
                                    }}
                                />
                                <button
                                    type="submit"
                                    style={{
                                        padding: '10px 18px',
                                        backgroundColor: '#6366F1',
                                        color: '#FFFFFF',
                                        border: 'none',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        fontWeight: 500,
                                        cursor: 'pointer',
                                        fontFamily: "'Inter', sans-serif",
                                        letterSpacing: '1px',
                                        textTransform: 'uppercase',
                                        transition: 'background-color 0.3s',
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#4F46E5')}
                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#6366F1')}
                                >
                                    Join
                                </button>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div
                    style={{
                        borderTop: '1px solid rgba(99, 102, 241, 0.15)',
                        padding: '20px 24px',
                        maxWidth: '1400px',
                        margin: '0 auto',
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: '12px',
                    }}
                >
                    <p style={{ fontFamily: "'Inter', sans-serif", fontSize: '12px', color: 'rgba(255,255,255,0.4)', margin: 0 }}>
                        &copy; 2026 Chandni. All rights reserved.
                    </p>
                    <div style={{ display: 'flex', gap: '20px' }}>
                        {legalLinks.map((link) => (
                            <span
                                key={link.label}
                                onClick={() => navigate(link.path)}
                                style={{
                                    fontFamily: "'Inter', sans-serif",
                                    fontSize: '12px',
                                    color: 'rgba(255,255,255,0.4)',
                                    cursor: 'pointer',
                                    transition: 'color 0.3s',
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.color = 'rgba(255,255,255,0.8)')}
                                onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255,255,255,0.4)')}
                            >
                                {link.label}
                            </span>
                        ))}
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer7;
